import React from 'react';
import { BackButtonProps } from './BackButton.types';
import { Button, StyledArrowLeft } from './BackButton.styled';

export const BackButton = ({
  title,
  onClick,
  color,
  ...rest
}: BackButtonProps) => {
  return (
    <Button onClick={onClick} color={color} {...rest}>
      <StyledArrowLeft fill={color} /> {title}
    </Button>
  );
};
